import React from 'react';

/**
 * Boutons segmentés : sens, base, mode de frais.
 *
 * Rendu en radiogroup plutôt qu'en suite de boutons : un lecteur d'écran
 * annonce alors « 1 sur 2 » et l'option retenue, ce qu'une rangée de boutons ne
 * dit pas.
 */
export default function Segmente({ etiquette, options, valeur, onChange, compact = false, aide = null }) {
  return (
    <div>
      {etiquette && (
        <div className="etiquette" style={{ marginBottom: 'var(--espace-1)' }}>
          {etiquette}{aide}
        </div>
      )}
      {/* Au-delà de deux options, les libellés se cassent en deux sur un
          téléphone - « À ma charge » sur deux lignes, de hauteur inégale avec
          ses voisins. La classe fait basculer le groupe en colonne sous
          480 px, où il y a la hauteur mais pas la largeur. */}
      <div
        role="radiogroup"
        aria-label={etiquette}
        className={options.length > 2 ? 'segmente segmente-large' : 'segmente'}
        style={{
          border: '1px solid var(--couleur-trait-fort)',
          borderRadius: 'var(--rayon)', overflow: 'hidden',
        }}
      >
        {options.map((o) => {
          const actif = o.valeur === valeur;
          return (
            <button
              key={o.valeur}
              type="button"
              role="radio"
              aria-checked={actif}
              onClick={() => onChange(o.valeur)}
              title={o.aide}
              style={{
                flex: 1,
                padding: compact ? 'var(--espace-1) var(--espace-2)' : 'var(--espace-2) var(--espace-3)',
                border: 'none',
                borderLeft: '1px solid var(--couleur-trait)',
                // Encre et non accent : c'est ce que prescrit le design
                // system pour un groupe segmenté. Le teal reste réservé à ce
                // qu'on déclenche, le segmenté ne fait que choisir un état.
                background: actif ? 'var(--couleur-encre)' : 'transparent',
                color: actif ? 'var(--couleur-surface)' : 'var(--couleur-encre)',
                fontWeight: actif ? 600 : 400,
                fontSize: compact ? '0.8rem' : '0.9rem',
                transition: 'background 120ms',
              }}
            >
              {o.libelle}
            </button>
          );
        })}
      </div>
    </div>
  );
}
